import { render, staticRenderFns } from "./AdminLanguageSelector.vue?vue&type=template&id=118cffe9&scoped=true"
import script from "./AdminLanguageSelector.vue?vue&type=script&lang=js"
export * from "./AdminLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./AdminLanguageSelector.vue?vue&type=style&index=0&id=118cffe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cffe9",
  null
  
)

export default component.exports